// Cart Custom JavaScript
document.addEventListener("DOMContentLoaded", function () {
  // Handle quantity buttons
  const quantityButtons = document.querySelectorAll(".quantity-btn");

  quantityButtons.forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();

      const action = this.getAttribute("data-action");
      const lineKey = this.getAttribute("data-line-key");
      const input = this.parentElement.querySelector(".quantity-input");
      let currentQuantity = parseInt(input.value);

      if (action === "increase") {
        currentQuantity += 1;
      } else if (action === "decrease" && currentQuantity > 1) {
        currentQuantity -= 1;
      }

      // Update the input value
      input.value = currentQuantity;

      // Trigger the quantity input change event
      const event = new Event("change", { bubbles: true });
      input.dispatchEvent(event);
    });
  });

  // Handle quantity input changes
  const quantityInputs = document.querySelectorAll(".quantity-input");

  quantityInputs.forEach((input) => {
    input.addEventListener("change", function () {
      const lineKey = this.getAttribute("data-line-key");
      const quantity = parseInt(this.value);

      if (quantity < 1) {
        this.value = 1;
        return;
      }

      // Update cart via AJAX
      updateCartQuantity(lineKey, quantity);
    });
  });

  // Function to update cart quantity
  function updateCartQuantity(lineKey, quantity) {
    const formData = new FormData();
    formData.append("id", lineKey);
    formData.append("quantity", quantity);

    fetch("/cart/change.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        // Update cart count in header if it exists
        const cartCount = document.querySelector(".cart-count");
        if (cartCount) {
          cartCount.textContent = data.item_count;
        }

        // Reload the page to update totals
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error updating cart:", error);
      });
  }

  // Sticky checkout button functionality
  function handleStickyCheckout() {
    const stickyCheckout = document.getElementById("cart-sticky-checkout");
    const mainCheckoutButton = document.querySelector(
      '.cart-form button[type="submit"]'
    );

    if (!stickyCheckout || !mainCheckoutButton) return;

    function checkVisibility() {
      const mainButtonRect = mainCheckoutButton.getBoundingClientRect();
      const isMainButtonVisible =
        mainButtonRect.top < window.innerHeight && mainButtonRect.bottom > 0;

      if (isMainButtonVisible) {
        stickyCheckout.style.display = "none";
      } else {
        stickyCheckout.style.display = "block";
      }
    }

    // Check on scroll and resize
    window.addEventListener("scroll", checkVisibility);
    window.addEventListener("resize", checkVisibility);

    // Initial check
    checkVisibility();
  }

  // Initialize sticky checkout
  handleStickyCheckout();
});
